import { useState, useEffect } from 'react';
import { 
  getTestimonials, 
  getCompanyInfo, 
  getServices, 
  getImpactStories, 
  getPaymentOptions 
} from '../services/api';

export const useAppData = () => {
  const [data, setData] = useState({
    testimonials: [],
    companyInfo: null,
    services: [],
    impactStories: [],
    paymentOptions: [],
    benefits: [
      "Stay independent and out of a nursing home",
      "Build muscle strength and mass",
      "Reduce aches and pains", 
      "Become more mobile (some have even stopped using their walking aids!)",
      "Reduce their risk of falls",
      "Minimise symptoms of chronic conditions like diabetes, cardiovascular disease, dementia and Parkinson's",
      "Regain lost bone mineral density",
      "Improve memory and cognition",
      "Feel more energised and full of life!"
    ]
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);
        
        const [
          testimonialsData,
          companyData,
          servicesData,
          impactData,
          paymentData
        ] = await Promise.all([
          getTestimonials(),
          getCompanyInfo(),
          getServices(),
          getImpactStories(),
          getPaymentOptions()
        ]);

        setData(prevData => ({
          ...prevData,
          testimonials: testimonialsData,
          companyInfo: companyData,
          services: servicesData,
          impactStories: impactData,
          paymentOptions: paymentData
        }));
        
        setError(null);
      } catch (err) {
        console.error('Error fetching app data:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  return { data, loading, error };
};